<script>
  // @ts-check
  // import * as Sentry from "@sentry/sveltekit";
  import EmailSignupForm from "$lib/components/EmailSignupForm.svelte";

  /** @type { string } */
  let className = "";
  export { className as class };

  /** The type of layout under the featured layout
   * @type { "vertical" | "horizontal" }
   */
  export let layoutVariant = "horizontal";

  export let data;
  export let result;
  export let submitButtonId = `gtmEmailSignUp-${data.sys.id}`;
  const fields = data?.fields || data;

  const imageFields = fields?.image?.fields;

  const formFields = {
    firstName: {
      label: fields?.firstNameLabel,
      required: true,
      errorMessage: fields?.firstNameError
    },
    lastName: {
      label: fields?.lastNameLabel,
      required: true,
      errorMessage: fields?.lastNameError
    },
    email: {
      label: fields?.emailAddressFieldLabel,
      required: true,
      errorMessage: fields?.emailAddressError
    },
    termsOfService: {
      label: fields?.termsOfServiceCheckboxLabelMarkdown,
      required: true,
      errorMessage: fields?.termsOfServiceError
    }
  };
</script>

<EmailSignupForm
  campaignId={fields?.campaignId}
  {submitButtonId}
  class={className}
  image={imageFields}
  {layoutVariant}
  title={fields?.title}
  description={fields?.description}
  titleConfirmationPage={fields?.successTitle}
  subTitleConfirmationPage={fields?.successSubtitle}
  descriptionConfirmationPage={fields?.successDescription}
  submitButtonText={fields?.submitButtonText}
  {formFields}
  bind:result
/>
